// CustomCursor.js
import React, { useEffect, useState } from 'react';
import './CustomCursor.css'; // Create this file for styling the cursor

import { useSelector } from "react-redux";
const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const cursorHover = useSelector((state)=>state?.app?.cursorHover);
  const cursorHoverText = useSelector((state)=>state?.app?.cursorHoverText);
  const cursorHoverTextBg = useSelector((state)=>state?.app?.cursorHoverTextBg);
  const cursorHoverTextColor = useSelector((state)=>state?.app?.cursorHoverTextColor);
  const cursorHoverTextdirection = useSelector((state)=>state?.app?.textDirection);

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (<div>
    <div
      className={`custom-cursor ${cursorHover ? 'hovered' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
      

    > </div>{cursorHoverText?<div  className={cursorHoverTextdirection=="right"?'custom-cursor-text-right':'custom-cursor-text'} style={{left: `${
      cursorHoverTextdirection=="right"?position.x-120:position.x+120}px`,
    top: `${position.y}px`,
  padding:"10px 19px", background:cursorHoverTextBg,textAlign:"center",color:cursorHoverTextColor}}>
    {cursorHoverText}
    
    </div>:""}
    
  </div>);
};

export default CustomCursor;
